function EventBuilder (name, payload) {
  return new CustomEvent(name, { detail: payload })
}

export default EventBuilder
